import React, { useState, useEffect } from 'react';
import MandirBack from '../images/mandir-back.jpg';
import eveImg2 from '../images/eveimg2.jpg';
import room1 from '../images/room1.jpg';
import room2 from '../images/room2.jpg';
import room3 from '../images/room3.jpg';
import room4 from '../images/room4.jpg';
import CheckIn from '../images/checkin.png';
import hygiene from '../images/hygiene.png';
import wifi from '../images/wifi.png';
import housekeep from '../images/housekeep.png';
import Carousel from 'react-bootstrap/Carousel';

import { useNavigate } from 'react-router-dom';

export default function MandirDetail() {

  const navigate = useNavigate();

  const [imgSlider, setimgSlider] = useState([])

  const imgArry = [
      {
          cap1 : 'First slide label',
          cap2 : 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
          img : room1,
      },
      {
          cap1 : 'First slide label',
          cap2 : 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
          img : room2,
      },
      {
          cap1 : 'First slide label',
          cap2 : 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
          img : room3,
      },
  ]

  const mndirImages = [
    {mndrimg : room1},
    {mndrimg : room1},
    {mndrimg : room1},
    {mndrimg : room1},
    {mndrimg : room1},
    {mndrimg : room1},
  ] 

  useEffect(()=>{
      setimgSlider(imgArry);
  },[])

  return (
    <div>
        <div className='mt-5'>
          <div class="main-div">
            <img class="background-div" src={MandirBack} alt="Sea Image" />
             <div className='container'>
              <div className='row p-5'>
                <div className='col-lg-12 col-md-8 col-sm-12 m-auto py-5'>
                  <div className='card bg-transparent border-0 text-center my-5'>
                    <div class="div-content py-4">
                      <p className='' style={{ fontFamily:'Poppins', fontSize:"2.5em", color:'#fff', fontWeight:400 }} >Finding your own place</p>
                    </div> 
                  </div>
                </div>
              </div>
             </div>
          </div>
        </div>
        <div className='container mt-5'>
          <div className='row'>
              <div className='col-lg-4 col-md-8 col-sm-12'>
                <div className='card rounded-0 border-0 mb-3' style={{ width:'100%' }} >
                     <img src={eveImg2} className="card-img-top rounded-0" alt="..." />
                 </div>
              </div>
              <div className='col-lg-8 col-md-6 col-sm-12'>
                <div className="py-2" style={{ fontFamily:'Poppins', fontSize:"1.3em", color:'#000000', fontWeight:500 }}>Dilwara Temple, Rajasthan</div>
                <div className="pb-2" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#00000099', fontWeight:400, lineHeight:1.6}}>The list of the finest Jain temples in India is incomplete without a mention of Dilwara Temples. The holy site is a short distance from Mount Abu, Rajasthan’s only hill station. The temples are popular not just for its religious value but is renowned for beautiful and artistic marble carvings.</div>
                <div className="pb-2" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#00000099', fontWeight:400, lineHeight:1.6}}>The five temples of Dilwara were built by dedicated Jain devotees in the 11th century. The five shrines are dedicated to Lord Adinath, Lord Rishabhdeo, Lord Neminath, Lord Mahavir Swami, and Lord Parshvanath respectively.</div>
              </div>
          </div>
        </div>
        <div className='container mt-5'>
        <p className='text-center' style={{ fontFamily:'Poppins', fontSize:"1.5em", color:'#000000', fontWeight:500 }}>Mandir images </p>
          <div className='row'>
              {
                mndirImages.map((item, index)=>{
                  return(
                    <div className='col-lg-2 col-md-6 col-sm-12'>
                      <div key={index} className='card rounded-0 border-0 mb-3' style={{ width:'100%' }} >
                        <img src={item.mndrimg} className="card-img-top rounded-0"  alt="..." />
                      </div>
                   </div>
                  )
                })
              }
          </div>
        </div>
          <div className='container my-5'>
         <div className='row'>
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <p className='' style={{ fontFamily:'Poppins', fontSize:"1.5em", color:'#1f5156', fontWeight:500 }}>Facilities</p>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>1. Free parking</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>2. Free Wi-Fi in all room</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>3. Food & dining</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>4. Daily housekeeping</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>5. Room service</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>6. Restaurant</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>7. Swimming pool</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>8. Garden</div>
              <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>9. Security & CCTV protection</div>
            </div>
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <p className='' style={{ fontFamily:'Poppins', fontSize:"1.5em", color:'#1f5156', fontWeight:500 }}>Address</p>
               <div className='row d-flex align-items-center'>
                 <div className='col-5'>
                   <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>State : </div>
                   <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>City : </div>
                   <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>Contact No. : </div>
                   <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>Contact time : </div>
                   <div className="py-1" style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:500 }}>Distance : </div>
                 </div>
                 <div className='col-6'>
                   <div className="py-1 text-start" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:400 }}>Rajasthan</div>
                   <div className="py-1 text-start" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:400 }}>Jaipur</div>
                   <div className="py-1 text-start" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:400 }}>+91 9874547145</div>
                   <div className="py-1 text-start" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:400 }}>(8 AM to 7 PM)</div>
                   <div className="py-1 text-start" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:400 }}>3 km from city</div>
                 </div>
               </div>
               <button onClick={()=> navigate('/Dharmshala')} className="btn-hover color-3 col-5 m-auto my-3">Accommodation</button>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12'>
              <p className='' style={{ fontFamily:'Poppins', fontSize:"1.5em", color:'#1f5156', fontWeight:500 }}>Map View</p>
               <div className="card rounded-1 border-0">
                 <div style={{ width: '100%',  }}>
                     <iframe
                     title="Google Map"
                     width="100%"
                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3166.524230345079!2d-122.08527488462054!3d37.42263487982975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808580d34f9f8a2d%3A0xd7cc38e84389676b!2sGolden%20Gate%20Bridge!5e0!3m2!1sen!2sus!4v1636902863367!5m2!1sen!2sus"
                     />
                 </div>
                </div>
            </div>
          </div>
                  <div className="py-4" style={{ fontFamily:'Poppins', fontSize:"12px", color:'#1f5156', fontWeight:500 }}>Get your trip off to a great start with a stay at this property, which offers free Wi-Fi in all rooms. Conveniently situated in the Belfast Waterfront Area part of Belfast, this property puts you close to attractions and interesting dining options. Don't leave before paying a visit to the famous Crumlin Road Gaol. This 3-star property features restaurant to make your stay more indulgent and memorable.</div>
        </div>
        <div className='container mt-5'>
            <div className='row'>
              <div className='card rounded-0 p-4'>
                <div className='row'>
                  <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                    <img src={CheckIn} alt="" style={{width:'12%'}} />
                    <div className="pt-2" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:500 }}>Check-in [24-hour]</div>
                  </div>
                  <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                    <img src={hygiene} alt="" style={{width:'12%'}} />
                    <div className="pt-2" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:500 }}>Hygiene Plus</div>
                  </div>
                  <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                    <img src={wifi} alt="" style={{width:'12%'}} />
                    <div className="pt-2" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:500 }}>Free Wi-Fi in all rooms!</div>
                  </div>
                  <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                    <img src={housekeep} alt="" style={{width:'12%'}} />
                    <div className="pt-2" style={{ fontFamily:'Poppins', fontSize:"14px", color:'#1f5156', fontWeight:500 }}>Daily housekeeping</div>
                  </div>
                </div>
              </div>
            </div> 
        </div>
    </div>
  )
}
